import { createFileRoute } from "@tanstack/react-router";
import { DelegationSettingsPage } from "@/features/tenant-settings/pages/delegation-settings-page";

export const Route = createFileRoute("/_authed/tenants/$slug/settings/delegation")({
  component: DelegationSettingsPage,
});
